/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionTypesControllerFindAllQueryResponse, TemplateQuestionTypesControllerFindAllQueryParams, TemplateQuestionTypesControllerFindAll401, TemplateQuestionTypesControllerFindAll403 } from "../../models/checklistsController/TemplateQuestionTypesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateQuestionTypesControllerFindAll } from "../../clients/checklistsService/templateQuestionTypesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateQuestionTypesControllerFindAllQueryKey = (params: TemplateQuestionTypesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-template-question-types'
}, ...(params ? [params] : [])] as const;
export type TemplateQuestionTypesControllerFindAllQueryKey = ReturnType<typeof templateQuestionTypesControllerFindAllQueryKey>;
export function templateQuestionTypesControllerFindAllQueryOptions(params?: TemplateQuestionTypesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateQuestionTypesControllerFindAllQueryKey(params);
  return queryOptions<TemplateQuestionTypesControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionTypesControllerFindAll401 | TemplateQuestionTypesControllerFindAll403>, TemplateQuestionTypesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateQuestionTypesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all checklist template question types
 * {@link /api/v1/checklist-template-question-types}
 */
export function useTemplateQuestionTypesControllerFindAll<TData = TemplateQuestionTypesControllerFindAllQueryResponse, TQueryData = TemplateQuestionTypesControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplateQuestionTypesControllerFindAllQueryKey>(params?: TemplateQuestionTypesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateQuestionTypesControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionTypesControllerFindAll401 | TemplateQuestionTypesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateQuestionTypesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templateQuestionTypesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateQuestionTypesControllerFindAll401 | TemplateQuestionTypesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}